import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import Header from './header'
import Headernew from './headernew'
import Footer from './footer'
import Promotion from './promotion'
import ProductLogoShowcase from './product-logo-showcase'
import './layout.css'

import '../fonts/fonts.css'
import '../styles/index.scss'
import '../styles/output.css'
import '../styles/custom.scss'
// import '../styles/blog.scss'

import { adRefCity } from '../helpers/adRefTracking'

const Layout = ({
  children,
  pageProps,
  footerLogoShowcase,
  isHomePage,
  customSchema,
}) => {
  //capture initial landing URL & date
  let isBetaEnabled =
    typeof window !== 'undefined' &&
    window.localStorage &&
    window.localStorage.getItem('BETA_FEATURES')

  if (
    typeof window !== 'undefined' &&
    window.localStorage &&
    !window.localStorage.getItem('landingURL')
  ) {
    window.localStorage.setItem('landingURL', pageProps.location.href)
    window.localStorage.setItem('landingDate', new Date())
  }
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
              description
              companyInfo {
                phone
                email
                addressLine1
                addressLine2
                city
                state
                zip
                license
              }
            }
          }

          contentfulOffer(featuredGlobalOffer: { eq: true }) {
            id
            title
            slug
            featuredGlobalOffer
            notificationBarActionText
            notificationBarText
          }

          allContentfulNavigation(filter: { campaign: { ne: null } }) {
            edges {
              node {
                id
                name
                menuItems {
                  id
                  name
                  title
                  url
                  openInNewWindow
                  submenu {
                    id
                    name
                    menuItems {
                      id
                      name
                      title
                      url
                      openInNewWindow
                      subMenuSection {
                        id
                        name
                        title
                        url
                        menuItems {
                          id
                          name
                          title
                          url
                          openInNewWindow
                        }
                      }
                    }
                  }
                  subMenuSection {
                    id
                    name
                    title
                    url
                    menuItems {
                      id
                      name
                      title
                      url
                      openInNewWindow
                    }
                  }
                }
                campaign
              }
            }
          }
        }
      `}
      render={(data) => (
        <>
          <Header
            globalOffer={data.contentfulOffer}
            siteTitle={data.site.siteMetadata.title}
            siteDescription={adRefCity(data.site.siteMetadata.description)}
            companyInfo={data.site.siteMetadata.companyInfo}
            mainNavigation={
              data.allContentfulNavigation.edges.filter(
                ({ node: { campaign } }) =>
                  campaign.length > 0 ? campaign[0] === 'default' : false
              )[0].node.menuItems
            }
            menus={data.allContentfulNavigation.edges}
            pageProps={pageProps}
          />

          <div className="layout-container">{children}</div>
          <ProductLogoShowcase footerLogoShowcase={footerLogoShowcase} />
          <Footer isHomePage={isHomePage} />
          <Promotion />
          {!customSchema && (
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: `
      [
        {
          "@context": "https://www.schema.org",
          "@type": "HomeAndConstructionBusiness",
          "@id": "https://www.gvdrenovationsinc.com#Roseville",
          "name": "GVD Renovations & Remodeling",
          "url": "https://www.gvdrenovationsinc.com",
          "logo": "https://images.ctfassets.net/79nimht05j33/5KXVC6MO76L5dlpGRcyHWe/a4aa833447743ec3de5a718d5b43fe0b/gvd-renovations-thumb2.jpeg",
          "image": "https://images.ctfassets.net/79nimht05j33/4agtFJcDsqbN9D0ohWiaP3/30a086aa90f96cc841e72dfa66f0e019/gvd-renovations-thumb.jpg",
          "description": "GVD Renovations & Remodeling is a locally owned and operated full-service home improvement contractor in Roseville & Sacramento, CA specializing in siding replacement, home remodeling, and exterior renovation services.",
          "telephone": "+1 916-269-0761",
          "priceRange": "$$",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "620 Commerce Dr Suite D",
            "addressLocality": "Roseville",
            "addressRegion": "CA",
            "postalCode": "95678",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "38.727582",
            "longitude": "-121.3037149"
          },
          "hasMap": "https://www.google.com/maps/place/GVD+Renovations/@38.727582,-121.3037149,17z/data=!3m1!4b1!4m5!3m4!1s0x809b20cb4a66170f:0x1e4f00143c05c7b4!8m2!3d38.727582!4d-121.3015262",
          "openingHours": "Mo, Tu, We, Th, Fr 08:00-18:00",
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1 916-269-0761"
          }
        },
        {
          "@context": "https://www.schema.org",
          "@type": "HomeAndConstructionBusiness",
          "@id": "https://www.gvdrenovationsinc.com#Rocklin",
          "name": "GVD Renovations Kitchen & Bath Showroom",
          "url": "https://www.gvdrenovationsinc.com",
          "logo": "https://images.ctfassets.net/79nimht05j33/5KXVC6MO76L5dlpGRcyHWe/a4aa833447743ec3de5a718d5b43fe0b/gvd-renovations-thumb2.jpeg",
          "image": "https://images.ctfassets.net/79nimht05j33/4agtFJcDsqbN9D0ohWiaP3/30a086aa90f96cc841e72dfa66f0e019/gvd-renovations-thumb.jpg",
          "description": "GVD Renovations & Remodeling is a premier home renovation company specializing in high-quality kitchen and bathroom remodels, full home renovations, room additions, and custom countertops. Our state-of-the-art Kitchen & Bath Design Showroom in Rocklin showcases a wide range of premium products and innovative designs to help bring your vision to life. With a commitment to exceptional craftsmanship and customer satisfaction, we transform homes into stunning, functional spaces. Proudly serving Rocklin, Roseville, Sacramento, and surrounding areas, we bring expertise, innovation, and top-tier materials to every project.",
          "telephone": "+1 916-269-0761",
          "priceRange": "$$",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "6848 Five Star Blvd #6",
            "addressLocality": "Rocklin",
            "addressRegion": "CA",
            "postalCode": "95677",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "38.7895",
            "longitude": "-121.2341"
          },
          "hasMap": "https://maps.app.goo.gl/dkhXxZd6BwY87mEEA",
          "openingHours": "Mo, Tu, We, Th, Fr 08:00-18:00",
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1 916-269-0761"
          }
        }
      ]`,
              }}
            />
          )}
        </>
      )}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout

//classes for tailwind to include when doing purge
// pr-2
